import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["accept"]

import { computed, ref } from 'vue'

/**
 * Component that contains a hidden file input that has the visible component slotted into it
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'FileSelector',
  props: {
    accept: null
  },
  emits: ["fileSelected"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'fileSelected', file: File): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  accept: string[]
};





const acceptedFiles = computed(() => props.accept.join(','))

const fileInput = ref<HTMLInputElement | null>(null)

const onSelectFile = () => {
  if (fileInput.value) {
    fileInput.value.click()
  }
}

const onFileChange = () => {
  if (fileInput.value) {
    if (fileInput.value.files && fileInput.value.files.length === 1) {
      const file = fileInput.value.files.item(0)
      if (file) {
        emits('fileSelected', file)
      }
    }
    // Resets the input value to allow consecutive reuploads of a file
    fileInput.value.value = ''
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: "file-selector__slot",
      onClick: onSelectFile
    }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _withDirectives(_createElementVNode("input", {
      ref_key: "fileInput",
      ref: fileInput,
      type: "file",
      accept: _unref(acceptedFiles),
      onChange: onFileChange
    }, null, 40, _hoisted_1), [
      [_vShow, false]
    ])
  ], 64))
}
}

})